$(document).ready(() => {

    $('.js-filter-projects').click(function(e){
        e.preventDefault();
        $(this).addClass('active').siblings('.js-filter-projects').removeClass('active');
        $(this).parents('.block-filter').find('.js-filter-projects2').removeClass('active');
        $(this).parents('.block-filter').find('.js-filter-projects2').hide();
        $(this).parents('.block-filter').find('.js-filter-projects2[data-parent="' + $(this).data('id') + '"]').show();
        filterProjects($(this));
    });

    $('.js-filter-projects2').click(function(e){
        e.preventDefault();
        $(this).addClass('active').siblings('.js-filter-projects2').removeClass('active');
        filterProjects($(this));
    });

     function filterProjects($el){
         let categories = [];
         let filterParent = $el.parents('.block-filter');

         filterParent.find('.js-filter-projects.active').each(function(){
             categories.push($(this).data('id'));
         });
         if (filterParent.find('.js-filter-projects2[data-parent="' + filterParent.find('.js-filter-projects.active').data('id') + '"]').length) {
             categories = [];
             filterParent.find('.js-filter-projects2[data-parent="' + filterParent.find('.js-filter-projects.active').data('id') + '"]').each(function(){
                 categories.push($(this).data('id'));
             });
         }
         if (filterParent.find('.js-filter-projects2.active').length) {
             categories = [];
             filterParent.find('.js-filter-projects2.active').each(function(){
                 categories.push($(this).data('id'));
             });
         }

         $('.loader').show();
         $.ajax({
             url: myajax.url,
             dataType: 'json',
             method: 'POST',
             data: {
                 action: 'filter_projects',
                 categories: categories,
             },
             success(data) {
                 $el.parents('.projects').find('.block-projects-wrap').remove();
                 $el.parents('.projects .container').append(data.content);
             },
             complete: function(){
                 $('.loader').hide();
             },
         });
     }
});
